__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@immense-ui/shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(254), __webpack_require__.e(381), __webpack_require__.e(657)]).then(() => (() => (__webpack_require__(53657))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(381), __webpack_require__.e(342), __webpack_require__.e(516)]).then(() => (() => (__webpack_require__(47516))))));
			register("@immense-ui/core", "1.0.0", () => (Promise.all([__webpack_require__.e(474), __webpack_require__.e(25), __webpack_require__.e(381), __webpack_require__.e(512), __webpack_require__.e(791), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(55512))))));
			register("@mui/private-theming", "9.4.0", () => (Promise.all([__webpack_require__.e(381), __webpack_require__.e(625)]).then(() => (() => (__webpack_require__(52625))))));
			register("@rollbar/react", "1.0.0", () => (Promise.all([__webpack_require__.e(910), __webpack_require__.e(11), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(44011))))));
			register("@tanstack/react-query", "4.44.0", () => (Promise.all([__webpack_require__.e(662), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(57662))))));
			register("axios", "1.16.0", () => (__webpack_require__.e(16).then(() => (() => (__webpack_require__(97016))))));
			register("i18next", "25.7.3", () => (__webpack_require__.e(313).then(() => (() => (__webpack_require__(15313))))));
			register("react-cookie", "8.0.1", () => (Promise.all([__webpack_require__.e(667), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(33667))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(43144))))));
			register("react-i18next", "15.7.4", () => (Promise.all([__webpack_require__.e(806), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(87806))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(149), __webpack_require__.e(381)]).then(() => (() => (__webpack_require__(4149))))));
			register("react", "18.3.1", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(14041))))));
			initExternal(61996);
			initExternal(60591);
			initExternal(7231);
			initExternal(38875);
			initExternal(1259);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};